export interface ICodigoItem {
    sigla: string | null;
    descricao: string;
    codigo: string;
    grupo_id: string | null;
    grupo_nome: string | null;
    descricoes: string[];
    atualizado_em: string;
    resolvida: boolean;
    usuario_id: number | null;
    tipo: string;
    tipo_descricao: string;
}

export interface ISistemaItem {
    sistema: string;
    label: string;
    codigos: ICodigoItem[];
}

export interface IReceitaDetalhe {
    codigo_mestre: string;
    tipo: string;
    tipo_descricao: string;
    status: string;
    resolvidos: number;
    total: number;
    atualizado_em: string;
    sistemas: ISistemaItem[];
}

export interface IAtribuicaoItem {
    sistema: string;
    codigo: string;
    grupo_id: string;
}

export interface IReceitaPatchPayload {
    atribuicoes: IAtribuicaoItem[];
}

export interface SIContabeis {
    sistema: string;
    label: string;
    codigos: string[];
}

export interface IReceitasConfiguracoes {
    codigo_mestre: string;
    tipo: string;
    tipo_descricao: string;
    status: string;
    resolvidos: number;
    total: number;
    atualizado_em?: string;
    sistemas: SIContabeis[];
}

export interface IQuantidadesConfiguracoesReceitas {
    quantidade: number;
}

export interface IGrupos {
    id: string;
    ordem: string;
    usuario_id: number;
    nome: string;
    atualizado_em: string;
    tipo: number;
    tipo_descricao: string;
}

export interface IRegras {
    id: string;
    ano: number;
    usuario_id: number;
    atualizado_em: string;
    itens: IItemRegra[];
}

export interface IItemRegra {
    nome: string;
    categoria: string;
    prefixos: string[];
}

export interface IRegrasFormValues {
    ano: number;
    itens: IItemRegra[];
}


export const STATUS_TAG_COLOR: Record<string, { label: string, color: string }> = {
    'nao_resolvido': {
        label: 'Não Resolvido',
        color: 'red',
    },
    'resolvido': {
        label: 'Resolvido',
        color: 'green',
    },
    'parcial': {
        label: 'Parcial',
        color: 'blue',
    },
};

export interface IGerenciarMunicipiosItem {
    id_ibge: number;
    nome: string;
    uf: string;
    sistema: string;
    sistema_slug: string;
    atualizado_em: string;
    total_periodos: number;
    anos: number[];
    conflito: boolean;
}

export interface IGerenciarMunicipios {
    total_geral: number;
    total_conflitos: number;
    total_filtrado: number;
    municipios: IGerenciarMunicipiosItem[];
}

export interface IMunicipioAtributo {
    chave: string;
    valor: string;
    sensivel: boolean;
}

export interface IMunicipioPeriodo {
    ano: number;
    meses: number[];
    atualizado_em: string;
}

export interface IItemDetalhesMunicipio {
    id_ibge: number;
    nome: string;
    uf: string;
    sistema: string;
    sistema_slug: string;
    atualizado_em: string;
    atributos: IMunicipioAtributo[];
    periodos: IMunicipioPeriodo[];
    conflito: boolean;
    outros_sistemas: any[];
}

export interface IPeriodoReprocessar {
    ano: number;
    mes: number;
}

export interface IReprocessarMunicipioPayload {
    periodos: IPeriodoReprocessar[];
}

